import Theme from 'components/common/Theme/Theme'

const PromotionSpotlightStyles = `
  & .promotion-banner-container {
    margin: auto;
    position: relative;
    width: 288px;
    height: 288px;
    background-size: contain;

    .promotion-banner-cta {
      position: absolute;
      display: block;
      bottom: 0;
      left: 0;
      right: 0;
      text-align: center;
      padding: 20px;
      background: ${Theme.colors.black};
      color: ${Theme.colors.white};
    }
  }
`

export default PromotionSpotlightStyles
